import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import ReplyIcon from '@mui/icons-material/Reply'

import { ActionCardProps } from 'types/TextAnalysis'
import { StyledTypography } from '../Helper'

const Wrapper = styled(Box)`
  cursor: pointer;
  gap: 0.5rem;
  padding-top: 0.75rem;
  pointer-events: none;
`

const trimText = (text: string, limit: number) => {
  if (text.length > limit) {
    return `${text.substring(0, limit)}...`
  }
  return text
}

const IdeasCommentTitleLink = ({
  cardTitleLink,
  handleIdeasCommentTitleClick,
}: ActionCardProps) => {
  if (!cardTitleLink) return null

  return (
    <Wrapper
      width="100%"
      display="flex"
      color="primary.main"
      data-testid="ideas-comment-title-link"
      onClick={() => handleIdeasCommentTitleClick?.()}
    >
      <ReplyIcon />
      <StyledTypography
        variant="body"
        dangerouslySetInnerHTML={{
          __html: trimText(String(cardTitleLink), 64),
        }}
      />
    </Wrapper>
  )
}

export { IdeasCommentTitleLink }
